import React from "react";
import {
  Box,
  Divider,
  Typography,
  makeStyles,
  Avatar,
  Checkbox,
  useTheme,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDivider-root": {
      height: 1,
      width: "100%",
      marginTop: theme.spacing(1),
    },
  },
}));

const CompanySignals = ({
  selectedSignals,
  signalCategories,
  onSignalUpdate,
}) => {
  const classes = useStyles();
  return (
    <Box my={2} className={classes.root}>
      <Typography variant="body1" color="textSecondary">
        Mark required signal categories
      </Typography>
      <Divider />
      <Box
        display={"flex"}
        justifyContent="flex-start"
        alignItems={"center"}
        flexWrap={"wrap"}
        my={4}
        mx="auto"
      >
        {signalCategories.map((signal) => {
          return (
            <SignalCategory
              signalCategory={signal}
              isSelected={
                selectedSignals && selectedSignals.includes(signal.id)
              }
              key={signal.id}
              onSelect={(id, value) => onSignalUpdate(id, value)}
            />
          );
        })}
      </Box>
    </Box>
  );
};
export default CompanySignals;

const SignalCategory = ({ signalCategory, isSelected, onSelect }) => {
  const theme = useTheme();

  return (
    <Box
      display={"flex"}
      flexDirection="column"
      alignItems={"center"}
      width={"20%"}
      mb={2}
    >
      <Avatar
        src={signalCategory.icon}
        style={{ width: 48, height: 48, mb: theme.spacing(2) }}
      />
      <Typography variant="body1" color="textSecondary">
        {signalCategory.name}
      </Typography>
      <Checkbox
        color="primary"
        checked={isSelected}
        onChange={(event) => onSelect(signalCategory.id, event.target.checked)}
      />
    </Box>
  );
};
